/**
 *  @class
 *  @function SearchDrawer
 */
if (!customElements.get('search-drawer')) {
  class SearchDrawer extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.search-overlay__input');
      this.resultsWrapper = this.querySelector('.search-overlay__results');
      this.grid = this.querySelector('.search-overlay__grid');
      this.form = this.querySelector('.search-overlay__form');

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.search-drawer-toggle')) return;
        e.preventDefault();
        OverlayManager.open(this, ['open-search']);
        setTimeout(() => {
          this.input.focus({ preventScroll: true });
        }, 100);
        this.fetchResults();
        dispatchCustomEvent('search:open');
      });

      this.form.addEventListener('submit', (e) => {
        if (!this.getQuery().length) e.preventDefault();
      });

      this.input.addEventListener('input', debounce(() => {
        this.fetchResults();
      }, 300).bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    getRecentlyViewedIds() {
      if (!window.localStorage) return [];
      const stored = window.localStorage.getItem('recently-viewed');
      if (!stored) return [];
      try {
        return JSON.parse(stored) || [];
      } catch (e) {
        return [];
      }
    }

    fetchResults() {
      const query = this.getQuery();

      this.resultsWrapper.classList.toggle('has-query', query.length > 0);

      if (!query.length) {
        const recentIds = this.getRecentlyViewedIds().slice(0, 8);

        if (!recentIds.length) {
          this.grid.innerHTML = '';
          this.resultsWrapper.classList.add('is-empty');
          return;
        }

        this.resultsWrapper.classList.remove('is-empty');
        const recentQuery = recentIds.map((handle) => `handle:${handle}`).join(' OR ');
        const url = `${theme.routes.search_url}?view=recently-viewed&type=product&view_context=search-drawer&q=${encodeURIComponent(recentQuery)}`;

        this.grid.classList.add('loading');
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const source = html.querySelector('.products');
            this.grid.innerHTML = source ? source.outerHTML : '';
            this.grid.classList.remove('loading');
          })
          .catch(() => {
            this.grid.classList.remove('loading');
          });

        return;
      }

      this.resultsWrapper.classList.remove('is-empty');
      this.grid.classList.add('loading');

      const url = `${theme.routes.predictive_search_url}?q=${encodeURIComponent(query)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=8&section_id=predictive-search`;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const source = html.querySelector('#shopify-section-predictive-search');
          this.grid.innerHTML = source ? source.innerHTML : '';
          this.grid.classList.remove('loading');
        })
        .catch(() => {
          this.grid.classList.remove('loading');
        });
    }
  }

  customElements.define('search-drawer', SearchDrawer);
}
